module.exports = __webpack_public_path__ + "img/cheetah.dc60cb26.jpg";